import { TextFieldProps } from '@mui/material/TextField';
import { ReactElement } from 'react';

import { useWindowSize } from 'hooks';

import { StyledTextField } from './styled';

export function CompanySelectBaseTextField({
  name,
  size,
  variant = 'standard',
  error,
  value = '',
  label,
  onBlur,
  ...otherProps
}: TextFieldProps): ReactElement {
  const { isMobile } = useWindowSize();
  const charLimit = isMobile ? 20 : 30;
  const newValue: string = value ? `${value}` : '';
  const newDisplayLabel =
    newValue.length > charLimit ? `${newValue.slice(0, charLimit)}...` : newValue;
  return (
    <StyledTextField
      fullWidth
      size={size}
      variant={variant}
      error={error}
      value={newValue}
      label={newDisplayLabel}
      autoComplete="off"
      onBlur={onBlur}
      {...otherProps}
    />
  );
}
